// This function allow to reference async chunks
__webpack_require__.u = (chunkId) => {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"25":"1c7d283f","349":"7d8b4a49","357":"68f0ba58","393":"d11263bf","648":"d276a781","766":"037ad774","975":"944393a1"}[chunkId] + ".chunk.js";
};